import withStyles from 'src/common/withStyles';
import React, { FC, useCallback } from 'react';
import { Field, Form } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Button from '../../../../common/components/Button';
import FormError from '../../../../common/components/FormError';
import Input from '../../../../common/components/inputs/Input';
import { verifyMFARecoveryCodeAction } from '../../../../common/ducks/user';
import { decorateComponent, rffSubmitResponse } from '../../../../common/helpers';
import { combineValidators, rffValidators } from '../../../../common/validation';
import { ReduxState } from '../../../../types/reduxState';

import s from './MFARecoveryForm.module.scss';

const codeValidate = combineValidators([
  rffValidators.required({ message: 'Please enter recovery code' }),
  rffValidators.maxLength({ message: 'The recovery code provided is not valid', length: 20 }),
]);

type MFARecoveryFormProps = {
  onSubmitSuccess: () => void;
};

const MFARecoveryForm: FC<MFARecoveryFormProps> = ({
  onSubmitSuccess,
}) => {
  const dispatch = useDispatch<ThunkDispatch<ReduxState, {}, Action>>();
  const onSubmit = useCallback(
    async (values: { code: string }) => dispatch(verifyMFARecoveryCodeAction(values))
      .then(onSubmitSuccess)
      .catch(rffSubmitResponse()),
    [
      dispatch,
      onSubmitSuccess,
    ],
  );
  return (
    <Form
      onSubmit={onSubmit}
    >
      {({ handleSubmit, submitError, submitting }) => (
        <form
          method="POST"
          onSubmit={handleSubmit}
          className={s.root}
        >
          <FormError error={submitError} />
          <fieldset>
            <Field
              name="code"
              placeholder="Recovery code"
              type="text"
              component={Input}
              validate={codeValidate}
            />
          </fieldset>
          <div className={s.actionGroup}>
            <Button
              type="submit"
              submitting={submitting}
            >
              Verify
            </Button>
          </div>
        </form>
      )}
    </Form>
  );
};

const decorators = [
  withStyles(s),
];

export default decorateComponent(MFARecoveryForm, decorators);
